import { useSelector } from "react-redux";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import { Alerts } from "./components/alerts/Alerts";
import {
  selectAlert,
} from "./features/alert.slice";

import { AuthUserRoute } from "./pages/navi/AuthUserRouter";
import { Portal } from "./pages/portal/Login";
import { SidebarWeb } from "./pages/portal/SidebarWeb";
import { EventParticipationWeb } from "./pages/portal/eventParticipationWeb/EventParticipationWeb";
import { EventParticipationWebInfo } from "./pages/portal/eventParticipationWeb/EventParticipationWebInfo";
import { SidebarMobile } from "./pages/portal/SidebarMobile";
import { EventParticipationMobile } from "./pages/portal/eventParticipationMobile/EventParticipationMobile";
import { PointHistoryListWeb } from "./pages/portal/pointHistoryWeb/PointHistoryListWeb";
import { PointHistoryListMobile } from "./pages/portal/pointHistoryMobile/PointHistoryListMobile";
import { PointHistoryWebInfo } from "./pages/portal/pointHistoryWeb/PointHistoryWebInfo";
import { PointHistoryMobileInfo } from "./pages/portal/pointHistoryMobile/PointHistoryMobileInfo";
import { PointHistoryWebHeldPointInfo } from "./pages/portal/pointHistoryWeb/PointHistoryWebHeldPointInfo";
import { PointHistoryMobileHeldPointInfo } from "./pages/portal/pointHistoryMobile/PointHistoryMobileHeldPointInfo";

const App = () => {
  const alert = useSelector(selectAlert);

  return (
    <>
      {alert.isOpen && (
        <Alerts color={alert.color} text={alert.text} sbuText={alert.subText}/>
      )}

      <BrowserRouter>
        <Routes>
          {/* ジョイン マイページ */}
          <Route path="/portal/login" element={<Portal></Portal>} />
          <Route path="/portal/" element={<AuthUserRoute><SidebarWeb /></AuthUserRoute>}>
            {/* イベント参加履歴 */}
            <Route path="eventParticipationWeb" element={<EventParticipationWeb />} />
            {/* お知らせ詳細 */}
            <Route path="eventParticipationWeb/:messageId/info" element={<EventParticipationWebInfo />} />
            {/* ポイント履歴一覧 */}
            <Route path="pointHistoryListWeb" element={<PointHistoryListWeb />} />
            {/* ポイント履歴詳細 */}
            <Route path="pointHistoryListWeb/:pointHistoryId/info" element={<PointHistoryWebInfo />} />
            {/* ポイント履歴 保有ポイント詳細 */}
            <Route path="pointHistoryListWeb/heldPointInfo" element={<PointHistoryWebHeldPointInfo />} />
          </Route>
          <Route path="/portal/" element={<AuthUserRoute><SidebarMobile /></AuthUserRoute>}>
            {/* イベント参加履歴 */}
            <Route path="eventParticipationMobile" element={<EventParticipationMobile />} />
            {/* お知らせ詳細 */}
            <Route path="eventParticipationMobile/:messageId/info" element={<EventParticipationWebInfo />} />
            {/* ポイント履歴一覧 */}
            <Route path="pointHistoryListMobile" element={<PointHistoryListMobile />} />
            {/* ポイント履歴詳細 */}
            <Route path="pointHistoryListMobile/:pointHistoryId/info" element={<PointHistoryMobileInfo />} />
            {/* ポイント履歴 保有ポイント詳細 */}
            <Route path="pointHistoryListMobile/heldPointInfo" element={<PointHistoryMobileHeldPointInfo />} />
          </Route>
          <Route path="/" element={<Portal></Portal>} />
        </Routes>
        <Routes></Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
